import { findAssociationOptionByValue, useFlexibleAssociations } from '../../hooks/useFlexibleAssociations';
import { useStrategy } from '../../hooks/useStrategy';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from 'customer-data-filters-ui/state/SegmentationFiltersInstanceContext';
import { isExcludedAssociation } from '../../fetcher/adapter/adapters/AssociationDefinitionsAdapter';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerAssociatedCrmObjectHeadingText = props => {
  const {
    logicGroup
  } = props;
  const {
    getFilterFamilyObjectName
  } = useStrategy();
  const {
    associationValue,
    associationOptions
  } =
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
  useFlexibleAssociations(logicGroup);
  const {
    props: {
      baseFilterFamily
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const baseObjectName = getFilterFamilyObjectName(baseFilterFamily);
  const associatedObjectName = getFilterFamilyObjectName(logicGroup.filterFamily);
  const selectedAssociationOption = findAssociationOptionByValue(associationOptions, associationValue);
  if (logicGroup.associationTypeId && logicGroup.associationCategory && isExcludedAssociation(logicGroup.associationTypeId, logicGroup.associationCategory)) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.CRM_OBJECT_BAD_ASSOCIATION",
        options: {
          entityName: associatedObjectName,
          baseObjectName
        }
      }), /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.badAssociationHint"
        })
      })]
    });
  }

  // if associations are empty use "Any" as association label
  if (associationOptions && associationOptions.length === 0) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.CRM_OBJECT_ANY",
      options: {
        entityName: associatedObjectName,
        baseObjectName
      }
    });
  }

  // primary association
  if (selectedAssociationOption && selectedAssociationOption.isPublicPrimary) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.CRM_OBJECT_PRIMARY",
      options: {
        entityName: associatedObjectName,
        baseObjectName
      }
    });
  }

  // wildcard/unlabeled association
  if (selectedAssociationOption && selectedAssociationOption.isWildcard) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.CRM_OBJECT_ANY",
      options: {
        entityName: associatedObjectName,
        baseObjectName
      }
    });
  }

  // labeled association with inverse label
  if (selectedAssociationOption && selectedAssociationOption.inverseText) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.CRM_OBJECT_LABELED_WITH_INVERSE_LABEL",
      options: {
        entityName: associatedObjectName,
        baseObjectName,
        associationLabel: selectedAssociationOption.text,
        inverseAssociationLabel: selectedAssociationOption.inverseText
      }
    });
  }

  // unlabeled association
  if (!(selectedAssociationOption !== null && selectedAssociationOption !== void 0 && selectedAssociationOption.text) && !associationValue) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.CRM_OBJECT_UNLABELED",
      options: {
        entityName: associatedObjectName,
        baseObjectName
      }
    });
  }

  // labeled association
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.CRM_OBJECT_LABELED",
    options: {
      entityName: associatedObjectName,
      baseObjectName,
      associationLabel: selectedAssociationOption ? selectedAssociationOption.text : associationValue
    }
  });
};
export default ViewerAssociatedCrmObjectHeadingText;